import EventView from '../../../../components/View/EventView';

export default EventView;